/**
 * Angular layout security notification toast — fixed top (full content, not ellipsis).
 * Content + duration from `GET /api/config/notification_content`.
 * × dismisses; toast also auto-hides after NOTIFICATION_TIME.
 */

import { ShieldAlert, X } from 'lucide-react'
import { useSecurityNotification } from './useSecurityNotification'

export function SecurityNotificationBanner() {
  const { message, remainingSeconds, dismiss } = useSecurityNotification()

  if (!message) return null

  const minutes = Math.floor(remainingSeconds / 60)
  const seconds = remainingSeconds % 60
  const timeLabel =
    minutes > 0
      ? `${minutes}m ${seconds.toString().padStart(2, '0')}s`
      : `${seconds}s`

  return (
    <div
      className="security-notification-toast"
      role="status"
      aria-live="polite"
      data-testid="security-notification-banner"
    >
      <ShieldAlert className="security-notification-toast__lead-icon" aria-hidden="true" />

      <div className="security-notification-toast__content">
        <div className="security-notification-toast__meta">
          <span className="security-notification-toast__title">Security notice</span>
          <span className="security-notification-toast__timer">
            Auto-hide in <strong>{timeLabel}</strong>
          </span>
        </div>
        {/* Full NOTIFICATION_CONTENT — wrap, never ellipse mid-message */}
        <p className="security-notification-toast__body">{message}</p>
      </div>

      <button
        type="button"
        className="security-notification-toast__dismiss"
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          dismiss()
        }}
        aria-label="Dismiss security notice"
        data-testid="security-notification-dismiss"
      >
        <X aria-hidden="true" />
      </button>
    </div>
  )
}
